import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { getUaDevice } from '@context/frontend/native/platform';

@Component({
	imports: [NgTemplateOutlet],
	selector: 'ctx-page-template',
	templateUrl: 'page-template.component.html',
	styleUrl: 'page-template.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.mode]': 'mode()',
		'[attr.nocurve]': 'nocurve()',
	},
})
export class PageTemplateComponent {
	readonly device = getUaDevice();

	/**
	 * the mode of the page template, this determines how the scroll behavior
	 * should be given what the expected contents of the page will be.
	 *
	 * detail - if the template should handle scrolling
	 * table - if the template will offload the scrolling to the table element
	 * and the table element will grow to be the size of the page
	 */
	readonly mode = input<'detail' | 'table'>('detail');

	/**
	 * if the template should not have a curved border on the top
	 */
	readonly nocurve = input(false);
}
